module.exports = __webpack_public_path__ + "img/jaune-4.b2af197b.png";